import React from 'react'

// classes
import ListWrapper, { IProps as IListWrapperIProps } from './list_wrapper'

// helpers

interface ProfileListWrapperIProps extends IListWrapperIProps {
  currentPage: number;
}

const ProfileListWrapper: React.FC<ProfileListWrapperIProps> = ({
  children,
  getNextPage,
  initialLoad
}) => {
  return (
    <ListWrapper
      getNextPage={getNextPage}
      initialLoad={initialLoad}
    >
      {children}
    </ListWrapper>
  )
}

export default ProfileListWrapper
